var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDishSlice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 141,
    viewBox: "0 0 95 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.3177 108.065C71.9607 71.0751 52.238 53.3321 35.1514 39.6706C26.655 32.0856 11.7906 22.2421 8.74846 28.8026C4.83608 37.24 25.5779 45.646 36.3514 53.4212C58.5733 69.4586 71.349 89.3836 76.5935 101.529C81.8379 113.674 94.6746 145.056 83.3177 108.065Z",
    fill: "#AEE3D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8914 15.8621C13.217 12.49 15.4216 18.1891 18.4322 21.6879C19.6303 22.959 21.4699 25.2771 19.2427 24.3812C16.4589 23.2613 0.565746 19.2342 6.8914 15.8621Z",
    fill: "#AEE3D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9742 108.29C90.3994 112.144 88.8109 113.719 88.3753 115.725C88.2512 116.519 87.9121 117.751 87.5493 116.324C87.0958 114.54 83.5491 104.436 86.9742 108.29Z",
    fill: "#AEE3D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4775 87.194C62.8653 62.9916 37.3931 38.6725 25.2817 29.1586C24.9794 28.9212 24.7708 28.6029 24.6681 28.2325C24.4979 27.6191 25.1543 27.1062 25.7083 27.4196L28.9602 29.2593C30.6134 30.4037 36.8868 35.8768 48.755 48.6143C63.5902 64.5362 69.9512 78.8012 71.4775 87.194Z",
    fill: "#AEE3D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishSlice);
export default __webpack_public_path__ + "static/media/dishSlice.466b0f19a471e1545c23ba65a9e85aee.svg";
export { ForwardRef as ReactComponent };